import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Disable React.StrictMode for production
const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

root.render(app);
